import { CEInvoiceAttributesBase } from './ce-invoice-attributes-base'


export class CEInvoiceAttributes extends CEInvoiceAttributesBase {

}